export const styles = {
  mainContainer: { overflowY: "auto" }
};
